import { memo } from 'react';

import { AssetModalContentHeaderCustomFields } from '~/components/v2/components/asset-modal/desktop/content/header/AssetModalContentHeaderCustomFields';
import { usePublicAssetCustomFieldsData } from '~/hooks/usePublicAssetCustomFieldsData';

export const PublicAssetModalContentHeaderCustomFields = memo(() => {
  const { data: customFields } = usePublicAssetCustomFieldsData();

  return <AssetModalContentHeaderCustomFields customFields={customFields?.data} />;
});

PublicAssetModalContentHeaderCustomFields.displayName = 'PublicAssetModalContentHeaderCustomFields';
